var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7223 123.445C27.688 123.445 0 95.7567 0 61.7223C0 27.688 27.688 0 61.7223 0C73.2517 0 84.4974 3.1997 94.2458 9.25465C95.9495 10.3118 96.4716 12.5506 95.4144 14.2546C94.3553 15.9582 92.1165 16.4841 90.4145 15.4231C81.8179 10.0828 71.896 7.26166 61.7223 7.26166C31.6923 7.26166 7.26139 31.6934 7.26139 61.7226C7.26139 91.7518 31.6923 116.183 61.7223 116.183C91.7515 116.183 116.183 91.7515 116.183 61.7223C116.183 55.6863 115.204 49.7598 113.271 44.1077C112.623 42.211 113.636 40.1461 115.533 39.4974C117.434 38.8526 119.495 39.8625 120.143 41.7592C122.333 48.1697 123.445 54.8865 123.445 61.7226C123.445 95.7567 95.7567 123.445 61.7223 123.445Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7224 82.6624C60.8015 82.6624 59.9109 82.3125 59.2368 81.6771L30.191 54.392C28.7293 53.0193 28.6574 50.7216 30.0304 49.2599C31.4034 47.8001 33.7008 47.7244 35.1625 49.1012L61.4145 73.7617L109.117 17.1336C110.406 15.6 112.698 15.4034 114.232 16.6967C115.765 17.9883 115.962 20.2782 114.669 21.8118L64.4985 81.371C63.8574 82.133 62.9289 82.5983 61.9342 82.657C61.8644 82.6605 61.7925 82.6624 61.7224 82.6624Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6453aeb833041326f985dd81c918f144.svg";
export { ForwardRef as ReactComponent };